var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlagFilled({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "flag-filled-svg",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    className: "svg flag-filled",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M21,5c-3.1,0-5.8-2-10.1-2c-1.7,0-3.4,0.3-5,0.9C6,3.5,6,3.1,6,2.7C5.8,1.2,4.7,0.1,3.2,0C1.5-0.1,0.1,1.2,0,2.9 C0,2.9,0,3,0,3c0,1.1,0.6,2.1,1.5,2.6V31c0,0.5,0.4,1,0.9,1c0,0,0.1,0,0.1,0h1c0.5,0,1-0.4,1-0.9c0,0,0-0.1,0-0.1v-5.2 c2.5-1.2,5.2-1.9,8-1.8c3.1,0,5.8,2,10.1,2c2.9,0,5.7-0.9,8-2.5C31.5,23,32,22,32,21V6c0-1.7-1.3-3-2.9-3.1c-0.4,0-0.9,0.1-1.3,0.3 C25.7,4.3,23.4,4.9,21,5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagFilled);
export default __webpack_public_path__ + "static/media/flag-filled.31ab1d63b228d9f6be36317e3a4426e7.svg";
export { ForwardRef as ReactComponent };